const playerOptions = [
  { label: "Left", value: "L" },
  { label: "Right", value: "R" },
  { label: "Both", value: "B" }
];

export default playerOptions;



// WEBPACK FOOTER //
// ./src/constants/playerHandOptions.js